import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JsignalService } from 'src/app/shared/services/jsignal.service';

interface CommentReply {
  author: string;
  role: string;
  text: string;
  timestamp: string;
  highlight?: boolean; 
}

interface CommentItem {
  section: string;
  author: string;
  role: string;
  text: string;
  timestamp: string;
  replies: CommentReply[];
  status: 'open' | 'resolved' | 'closed' | 'reopened';
  highlight?: boolean;
  commentId:any 
}

interface Comment {
  commentId:any,
  strategyId: string,
  versionId: string,
  comment: string,
  section:string,
  role:string,
  productID: string
} 

interface Commentreply{
  strategyId:any,
  role: string,        
  reply: any,  
  commentID:any
}

@Component({
    selector: 'app-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.scss'],
    standalone: false
})
export class CommentsComponent implements OnChanges {
  @ViewChildren('commentItem') commentItems!: QueryList<ElementRef>;

  @Input() strategyId!: any;
  @Input() sectionId!: string;
  @Input() role!: 'reviewer' | 'author' | 'approver';
  @Input() ProductId!:string;
  @Input() commentsData: any[] = [];
  @Input() isFirstLoad: boolean = true;

  @Output() cancel = new EventEmitter<boolean>();
  @Output() action = new EventEmitter<{ id: number; action: string; comment: string }>();
  // below Output Send the No. Of Open Comments in each section 
  @Output() commentCounts = new EventEmitter<{ [sectionId: string]: number }>();
  //below output sends total no. of Open Comments in Full Received CommentJson
  @Output() totalOpenComments = new EventEmitter<number>();

  

  commentText: string = '';
  backgroundColorButton = '';
  comments: CommentItem[] = [];
  replyText: string = '';
  activeReplyId: number | null = null;
  editingComment: CommentItem | null = null;
  editText: string = '';
  author:string;
  permissions = {
  reviewer: {
    canAdd: true,
    canMarkMandatory: true,
    canReply: true,
    canResolve: false,
    canClose: true
  },
  author: {
    canAdd: true,
    canMarkMandatory: false,
    canReply: true,
    canResolve: true,
    canClose: false
  },
  approver: {
    canAdd: true,
    canMarkMandatory: false,
    canReply: false,
    canResolve: false,
    canClose: true,  // approver validates closure
  }
};
  currentPermissions: any = null;
  selectedStatus: string = 'all';
  filteredComments: CommentItem[] = [];
  newComment:Comment[]=[];





  constructor(private localStorage: LocalStorageSettingsService,private snackBar: MatSnackBar, private jsignalsService: JsignalService) {
    this.backgroundColorButton = this.localStorage.getSettings('ColorA');
    this.author = this.localStorage.getSettings('AuthUser');
  }


ngOnChanges(changes: SimpleChanges) {
  const incoming = changes['commentsData']?.currentValue;

  // Sync reset flag
  if (changes['isFirstLoad']) {
    this.isFirstLoad = changes['isFirstLoad'].currentValue;
    console.log('🔄 Synced isFirstLoad from parent:', this.isFirstLoad);
  }

  // Case 1: Parent sent new comments → always use them
  if (changes['commentsData'] && incoming) {
    console.log(`🔔 Reloading comments from parent, length=${incoming?.length}`);
    this.loadCommentsForSection(this.sectionId, incoming);
    this.isFirstLoad = false;
  }

  // Case 2: Section changed but parent didn't send new data
  if (changes['sectionId'] && !changes['commentsData']) {
    if (this.commentsData?.length) {
      // ✅ still reuse parent comments if available
      this.loadCommentsForSection(this.sectionId, this.commentsData);
    } else {
      // ⏩ fallback to localStorage
      this.loadCommentsForSection(this.sectionId);
    }
  }

  // Update role permissions + filter
  this.currentPermissions = this.permissions[this.role];
  this.applyFilter();
}






  get canAdd() { return this.currentPermissions.canAdd; }
  get canMarkMandatory() { return this.currentPermissions.canMarkMandatory; }
  get canReply() { return this.currentPermissions.canReply; }
  get canResolve() { return this.currentPermissions.canResolve; }
  get canClose() { return this.currentPermissions.canClose; }

  triggerAction(actionType: string) {
    this.action.emit({
      id: this.strategyId,
      action: actionType,
      comment: this.commentText
    });
  }



//   loadCommentsForSection(sectionId: string) {
//   console.log('SectionId passed:', sectionId);

//   let allComments: any[] = [];

//   if (this.isFirstLoad && this.commentsData?.length) {
//     // ✅ First time load from parent input
//     allComments = this.commentsData;
//     this.isFirstLoad = false; // mark as loaded once
//     console.log('📦 First load from parent:', allComments);
//   } else {
//     // ⏩ Subsequent loads from localStorage
//     allComments = JSON.parse(localStorage.getItem('allCommentsJson') || '[]');
//     console.log('📦 Loaded from localStorage:', allComments);
//   }

// console.log("All before filtering:", allComments.map(c => ({id: c.id,Comment:c.comment, status: c.status, section: c.section})));

//   this.comments = allComments
//     .filter(c => c.section === sectionId && c.status.toLowerCase() !== 'deleted')
//     .map(c => ({
//       section: c.section,
//       author: c.commentBy,
//       role: c.role,
//       text: c.comment,
//       timestamp: c.createdAt,
//       status: c.status.toLowerCase(),
//       highlight: false,
//       commentId: c.id,
//       replies: (c.replies || []).map((r: any) => ({
//         author: r.repliedBy,
//         role: r.role,
//         text: r.reply,
//         timestamp: r.repliedAt,
//         highlight: false
//       }))
//     }));

//   console.log('Final comments:', this.comments);


//   // Build counts of open comments across all sections
//   const grouped: { [sectionId: string]: number } = {};
//   allComments
//     .filter(c => c.status.toLowerCase() === 'open')
//     .forEach(c => {
//       grouped[c.section] = (grouped[c.section] || 0) + 1;
//     });

//   // Emit to parent for badge updates
//   this.commentCounts.emit(grouped);
// }

loadCommentsForSection(sectionId: string, parentComments?: any[]) {
  console.log('SectionId passed:', sectionId);

  let baseComments: any[] = [];

  if (parentComments && parentComments.length) {
    baseComments = parentComments;
    console.log('📦 Loaded from parent input (raw):', baseComments.length);
  } else {
    const raw = localStorage.getItem('allCommentsJson');
    baseComments = raw ? JSON.parse(raw) : [];
    console.log('📦 Loaded from localStorage (raw):', baseComments.length);
  }

  // 🔄 Merge with localStorage overrides (adds/deletes before API refresh)
  const localRaw = localStorage.getItem('allCommentsJson');
  const localComments = localRaw ? JSON.parse(localRaw) : [];

  // Replace base items with local changes if same id, else keep both
  const merged: any[] = [...baseComments];
  localComments.forEach((lc: any) => {
    const idx = merged.findIndex(c => c.id === lc.id);
    if (idx > -1) {
      merged[idx] = lc; // update
    } else {
      merged.push(lc);  // add new
    }
  });

  console.log('▶ IDs/states before filter:', merged.map(c => ({
    id: c?.id,
    comment: c?.comment,
    section: c?.section,
    status: c?.status
  })));

  // Safe filtering
  const filtered = merged.filter(c => {
    const cSection = (c?.section || '').toString().trim();
    const targetSection = (sectionId || '').toString().trim();
    const status = (c?.status || '').toString().toLowerCase();
    return cSection === targetSection && status !== 'deleted';
  });

  console.log(`🔍 beforeFilter=${merged.length} afterFilter=${filtered.length}`);

  this.comments = filtered.map(c => ({
    section: c.section,
    author: c.commentBy,
    role: c.role,
    text: c.comment,
    timestamp: c.createdAt,
    status: (c.status || '').toString().toLowerCase(),
    highlight: false,
    commentId: c.id,
    replies: (c.replies || []).map((r: any) => ({
      author: r.repliedBy,
      role: r.role,
      text: r.reply,
      timestamp: r.repliedAt,
      highlight: false
    }))
  }));

  // 🔢 Build counts across all sections
  const grouped: { [sectionId: string]: number } = {};
  merged
    .filter(c => (c?.status || '').toString().toLowerCase() === 'open')
    .forEach(c => {
      grouped[c.section] = (grouped[c.section] || 0) + 1;
    });

    //  Calculate total open comments
    const totalOpen = Object.values(grouped).reduce((sum, n) => sum + n, 0);
    console.log(totalOpen);

  this.commentCounts.emit(grouped);
  this.totalOpenComments.emit(totalOpen);  // total across all
}





  addComment() {
  if (!this.commentText.trim()) return;

  const newComment: Comment = {
    section: this.sectionId,
    role: this.role,
    comment: this.commentText.trim(),
    strategyId: this.strategyId,
    versionId: "0.1",
    productID: this.ProductId,
    commentId: 1
  };

  this.jsignalsService.AddNewComment(newComment).subscribe({
    next: (res: any) => {
      

      // Save backend response (all sections) in localStorage
      localStorage.setItem('allCommentsJson', JSON.stringify(res));

      // Reload only for current section
      this.loadCommentsForSection(this.sectionId);
      this.applyFilter();

      // Clear text after save
      this.commentText = '';
    },
    error: (err) => {
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    }
  });
}


  startReply(commentId: number) {
    this.activeReplyId = commentId;
    console.log(this.activeReplyId);
  }

  sendReply(comment: CommentItem) {
    if (!this.replyText.trim()) return;
    

    const reply: Commentreply = {
      strategyId:this.strategyId,
      role:this.role,
      reply: this.replyText.trim(),  
      commentID:comment.commentId
    };

    this.jsignalsService.replyComment(reply).subscribe({
    next: (res: any) => {
      

      // Save backend response (all sections) in localStorage
      localStorage.setItem('allCommentsJson', JSON.stringify(res));

      // Reload only for current section
      this.loadCommentsForSection(this.sectionId);
      this.applyFilter();

      // Clear text after save
      this.commentText = '';
    },
    error: (err) => {
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    }
  });

   
    this.replyText = '';
    this.activeReplyId = null;
     
    // // scroll to this latest reply
    // setTimeout(() => this.scrollToLatest(), 100);
    //  // remove highlight after 3 sec
    // setTimeout(() => reply.highlight = false, 3000);
    // this.applyFilter();
  }

  resolveComment(commentId: number) {
  const newComment: Comment = {
    section: this.sectionId,
    role: this.role,
    comment: this.commentText.trim(),
    strategyId: this.strategyId,
    versionId: "0.1",
    productID: this.ProductId,
    commentId: commentId
  };

  this.jsignalsService.updateCommentStatus(newComment, 'RESOLVED').subscribe({
    next: (res: any) => {
      // Save backend response (all sections) in localStorage
      localStorage.setItem('allCommentsJson', JSON.stringify(res));

      // Reload only for current section
      this.loadCommentsForSection(this.sectionId);
      this.applyFilter();

      // Clear text after save
      this.commentText = '';
    },
    error: (err) => {
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    }
  });
}


  deleteComment(comment: CommentItem) {
    console.log(comment.commentId);
    // Block if logged-in role does not match comment.role OR user mismatch
  if (comment.role !== this.role || comment.author !== this.author) {
    this.snackBar.open(
      `You are not allowed to Delete this ${comment.role}'s comment`,
      'OK',
      { duration: 3000, panelClass: ['snackbar-warning'] }
    );
    return;
  }

  const newComment: Comment = {
    section: this.sectionId,
    role: this.role,
    comment: this.commentText.trim(),
    strategyId: this.strategyId,
    versionId: "0.1",
    productID: this.ProductId,
    commentId: comment.commentId 
  };

  this.jsignalsService.deleteComment(newComment).subscribe({
    next: (res: any) => {
      

      // Save backend response (all sections) in localStorage
      localStorage.setItem('allCommentsJson', JSON.stringify(res));

      // Reload only for current section
      this.loadCommentsForSection(this.sectionId);
      this.applyFilter();

      // Clear text after save
      this.commentText = '';
    },
    error: (err) => {
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    }
  });
  }

  editComment(comment: CommentItem) {
    // Block if logged-in role does not match comment.role OR user mismatch
  if (comment.role !== this.role || comment.author !== this.author) {
    this.snackBar.open(
      `You are not allowed to edit this ${comment.role}'s comment`,
      'OK',
      { duration: 3000, panelClass: ['snackbar-warning'] }
    );
    return;
  }
  this.editingComment = comment;
  this.editText = comment.text; // preload existing text

}
saveEdit() {
  if (!this.editingComment || !this.editText.trim()) {
    return;
  }

  const updatedComment: Comment = {
    section: this.sectionId,
    role: this.role,
    comment: this.editText.trim(),
    strategyId: this.strategyId,
    versionId: "0.1",
    productID: this.ProductId,
    commentId: this.editingComment.commentId
  };

  this.jsignalsService.EditComment(updatedComment).subscribe({
    next: (res: any) => {
      // Save backend response (all sections) in localStorage
      localStorage.setItem('allCommentsJson', JSON.stringify(res));

      // Reload only for current section
      this.loadCommentsForSection(this.sectionId);
      this.applyFilter();

      // Reset editing state
      this.editingComment = null;
      this.editText = '';
    },
    error: (err) => {
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    }
  });
}

cancelEdit() {
  this.editingComment = null;
  this.editText = '';
}


  private updateParent(actionType: string) {
    const allComments: CommentItem[] = JSON.parse(localStorage.getItem('allCommentsJson') || '[]');
    const filtered = allComments.filter(c => c.section !== this.sectionId);
    const updated = [...filtered, ...this.comments];
    localStorage.setItem('allCommentsJson', JSON.stringify(updated));
  }

  getInitials(value: string): string {
    if (!value) return 'NA';
    return value.substring(0, 2).toUpperCase();
  }

formatTimestamp(timestamp: string): string {

  if (!timestamp) {
    console.log('No timestamp provided → Output: "-"');
    return '-';
  }

  const m = moment(timestamp);
  if (!m.isValid()) {
    console.log('Invalid timestamp → Output: "-"');
    return '-';
  }

  const formatted = m.format('MMM D [at] h:mm a');  

  return formatted;
}
 private scrollToLatest() {
    const items = this.commentItems.toArray();
    if (items.length) {
      items[items.length - 1].nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }
onEnter(event: KeyboardEvent, type: 'comment' | 'reply', comment?: CommentItem) {
  if (event.shiftKey) {
    return; // allow newline
  }

  event.preventDefault(); // stop new line

  if (type === 'comment' && this.commentText.trim()) {
    this.addComment();
  } else if (type === 'reply' && comment && this.replyText.trim()) {
    this.sendReply(comment);
  }
}

// --- Role-specific ---
closeComment(commentId: number) {
 const newComment: Comment = {
    section: this.sectionId,
    role: this.role,
    comment: this.commentText.trim(),
    strategyId: this.strategyId,
    versionId: "0.1",
    productID: this.ProductId,
    commentId: commentId
  };

  this.jsignalsService.updateCommentStatus(newComment, 'CLOSED').subscribe({
    next: (res: any) => {
      // Save backend response (all sections) in localStorage
      localStorage.setItem('allCommentsJson', JSON.stringify(res));

      // Reload only for current section
      this.loadCommentsForSection(this.sectionId);
      this.applyFilter();

      // Clear text after save
      this.commentText = '';
    },
    error: (err) => {
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    }
  });
}

reopenComment(commentId: number) {
  const newComment: Comment = {
    section: this.sectionId,
    role: this.role,
    comment: this.commentText.trim(),
    strategyId: this.strategyId,
    versionId: "0.1",
    productID: this.ProductId,
    commentId: commentId
  };

  this.jsignalsService.updateCommentStatus(newComment, 'OPEN').subscribe({
    next: (res: any) => {
      // Save backend response (all sections) in localStorage
      localStorage.setItem('allCommentsJson', JSON.stringify(res));

      // Reload only for current section
      this.loadCommentsForSection(this.sectionId);
      this.applyFilter();

      // Clear text after save
      this.commentText = '';
    },
    error: (err) => {
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    }
  });

}

setFilter(status: string): void {
  this.selectedStatus = status;
  this.applyFilter();
}

applyFilter(): void {
  if (this.selectedStatus === 'all') {
    this.filteredComments = this.comments;
  } else {
    this.filteredComments = this.comments.filter(
      c => c.status.toLowerCase() === this.selectedStatus.toLowerCase()
    );
  }
}

getStatusCount(status: string): number {
  if (status === 'all') {
    return this.comments.length;
  }
  return this.comments.filter(
    c => c.status.toLowerCase() === status.toLowerCase()
  ).length;
}

onCancelClick() {
  this.cancel.emit(true);   // tell parent to reset isFirstLoad
}

getNoCommentsMessage(): string {
  if (!this.comments || this.comments.length === 0) {
    return "No comments found for selected section.";
  }

  if (this.selectedStatus && this.selectedStatus !== 'all') {
    return `No ${this.selectedStatus} comments found.`;
  }

  return "No comments found.";
}


}
